import { PaymentType } from "@/helpers/types/types.ts";
import { CalculatedCart } from "@/stores/EngineStore/interfaces/CalculatedCart.ts";

export const isInquiryPaymentType = (calculatedCart?: CalculatedCart): boolean => {
  return calculatedCart?.paymentConfig?.paymentType === PaymentType.Inquiry;
};
